import { FC, PropsWithChildren } from 'react';
import { ContentStyled } from './styled';

export const Content: FC<PropsWithChildren> = (props) => {
  return <ContentStyled {...props} />;
};
